const choices = {
    general: 'Clause générale',
    other: 'Autre',
};

export default choices;
